import { Component } from '@angular/core';
import { SnackBarService } from 'src/app/shared/services/snackbar.service';
import { PaymentService } from 'src/shared-app-portal/services/payment.service';
import { BasePaymentsDirective } from 'src/shared-app-portal/directives/base-payments.directive';

@Component({
  selector: 'app-portal-payments',
  templateUrl: './portal-payments.component.html',
  styleUrls: ['./portal-payments.component.scss'],
  standalone: false
})
export class PortalPaymentsComponent extends BasePaymentsDirective {
  constructor(
    protected paymentService: PaymentService,
    protected snackBarService: SnackBarService
  ) {
    super(paymentService, snackBarService);
  }
}
